import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';
import { tagProps } from './tag_table';
import { find, map, reduce } from 'lodash';

export default function MergeTagsModal({
  modalDisplay,
  selectedTag,
  selectedTags,
  onCloseModal,
  onMergeTags,
  onSelect
}) {
  const countData = () => {
    const mappedInstanceCount = map(selectedTags, tag => (
      tag.recordCountByType.totalCount
    ));

    const totalInstances = reduce(mappedInstanceCount, (sum, instances) => {
      return sum + instances;
    }, 0);

    return { totalTags: selectedTags.length, totalInstances: totalInstances };
  };

  const   handleTagSelect = (e) => {
    const tag = find(selectedTags, tag => (tag.id === parseInt(e.target.id)));

    onSelect(tag);
  };

  const setSelectableTags = () => {
    return map(selectedTags, tag => (
      <div className="form-check" key={tag.id}>
        <input
          checked={selectedTag === tag}
          className="form-check-input"
          id={tag.id}
          name="tag-selection"
          type="radio"
          onChange={handleTagSelect}
        />
        <label className="form-check-label" htmlFor={tag.id}>
          {tag.name}
        </label>
      </div>
    ));
  };

  const renderTagInstanceMessage = () => {
    const countedData = countData();
    let instanceMessage;

    if (countedData.totalInstances > 0) {
      const pluralize = countedData.totalInstances === 1 ? '1 instance' : `${countedData.totalInstances} instances`;
      instanceMessage = <span> that have <strong>{pluralize}</strong></span>;
    }

    return (
      <p>
        You are about to merge <strong>{countedData.totalTags} tags</strong>{instanceMessage}.
        Select the tag name that you would like everything merged under.
      </p>
    );
  };

  const renderTagForm = () => {
    return (
      <div className="form-group">
        {renderTagInstanceMessage()}
        <div className="form-input-container">
          {setSelectableTags()}
        </div>
      </div>
    );
  };

  const renderTagFooter = () => {
    return (
      <div>
        <button className="btn btn-ghost" name="cancel" onClick={onCloseModal}>
          Cancel
        </button>
        <button className="btn btn-primary" disabled={selectedTag == null} name="save" onClick={onMergeTags}>
          Merge Tags
        </button>
      </div>
    );
  };

  return (
    <div>
      <Modal
        name="tag-form-modal"
        show={modalDisplay}
        onHide={onCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Merge Tags
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {renderTagForm()}
          </div>
          <div className="mt-2">
            {renderTagFooter()}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

MergeTagsModal.propTypes = {
  modalDisplay: PropTypes.bool,
  selectedTag: PropTypes.object,
  selectedTags: PropTypes.arrayOf(tagProps).isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onMergeTags: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};
